import { CommonKeys } from "../../common/enums";
import { FormularGroup } from "./FormularGroup";

export interface FormularGroupArtikel extends FormularGroup {
  Artikel: FormularArtikel;
}

export interface FormularArtikel {
  [CommonKeys.Type]: string;
  [CommonKeys.Values]: Artikel[];
}

export interface Artikel {
  [CommonKeys.Type]: string;
  ArtikelID: string;
  ArtikelNr: string;
  Kurztext: string;
  Menge: number;
  Mengeneinheit: string;
  Preis: number;
  Aktion: FormularArtikelAktion;
}

export enum FormularArtikelAktion {
  None = 0,
  "Verbaut" = 1,
  "ZuBestellen" = 2,
  "Schadhaft" = 4,
  "AngebotErstellen" = 8,
}
